import * as TYPES from './lookups-actiontypes';

export const loadRelationshipsSuccess = (relationships) => (
  {
    type: TYPES.LOOKUPS_LOADRELATIONSHIPS_SUCCESS,
    relationships,
  }
);

export const loadCountriesSuccess = (countries) => ({
  type: TYPES.LOOKUPS_LOADCOUNTRIES_SUCCESS,
  countries,
});

export const loadPreferredCommunicationsSuccess = (preferredCommunications) => (
  {
    type: TYPES.LOOKUPS_LOADPREFERREDCOMMUNICATIONS_SUCCESS,
    preferredCommunications,
  }
);


export const loadStateSuccess = (states) => (
  {
    type: TYPES.LOOKUPS_LOADSTATES_SUCCESS,
    states,
  }
);

